import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import ListSubheader from '@mui/material/ListSubheader';
import { FormattedMessage } from 'react-intl';

import messages from '../messagesManageAccounts';
import inlineStyles from './accountGroupStyles';

const AssocServicesDetails = (props) => {
	const {
		values,
		onAuthenticationRealmChange,
		onAuthenticationRequestorIdChange,
		errors,
	} = props;

	return (
		<div>
			<ListSubheader style={inlineStyles.subHeader}>
				<FormattedMessage {...messages.lblGroupAssociatedServicesDetails} />
			</ListSubheader>

			<TextField
				id="srtAuthenticationRealm"
				label={<FormattedMessage {...messages.lblAuthenticationRealm} />}
				fullWidth
				value={values.authenticationRealm}
				onChange={onAuthenticationRealmChange}
				error={!!errors.authenticationRealm}
				helperText={errors.authenticationRealm}
				variant="standard"
			/>

			<TextField
				id="srtAuthenticationRequestorId"
				label={<FormattedMessage {...messages.lblAuthenticationRequestorId} />}
				fullWidth
				value={values.authenticationRequestorId}
				onChange={onAuthenticationRequestorIdChange}
				error={!!errors.authenticationRequestorId}
				helperText={errors.authenticationRequestorId}
				variant="standard"
			/>
		</div>
	);
};

AssocServicesDetails.propTypes = {
	values: PropTypes.object,
	onAuthenticationRealmChange: PropTypes.func.isRequired,
	onAuthenticationRequestorIdChange: PropTypes.func.isRequired,
	errors: PropTypes.object,
};

export default AssocServicesDetails;
